import { createStore, applyMiddleware, compose, combineReducers, GenericStoreEnhancer, Store, StoreEnhancerStoreCreator, ReducersMapObject } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import * as StoreModule from './store';
import { ApplicationState, reducers } from './store';
import { createBrowserHistory } from 'history'
export const history = createBrowserHistory()

const ConfigureStore = (history, initialState) => {
  // Build middleware. These are functions that can process the actions before they reach the store.
  const windowIfDefined = typeof(window) === 'undefined' ? null : window;
  // If devTools is installed, connect to it
    const devToolsExtension = windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__;
  const createStoreWithMiddleware = compose(
    applyMiddleware(thunk, routerMiddleware(history)),
    devToolsExtension ? devToolsExtension() :(next) => next)(createStore);

  // Combine all reducers and instantiate the app-wide store instance
  const allReducers = buildRootReducer(reducers);
  const store = createStoreWithMiddleware(allReducers, initialState);

  

  return store;
};
export default ConfigureStore;

function buildRootReducer(allReducers) {
    return combineReducers(Object.assign({}, allReducers(history), { routing: routerReducer }));
}
